import React, { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import "./styles.css"

export const SignaturePad = ({setSignature, signature}) => {

  const [showSignatureCanvas, setShowSignatureCanvas] = useState(false)
  const signatureRef = useRef();

  const clearSignature = () => {
    signatureRef.current.clear();
  };

  const saveSignature = () => {
    const signatureImage = signatureRef.current.toDataURL();
    setSignature(signatureImage);
  };

  return (
    <div>
      {showSignatureCanvas && (
        <>
          {signature ? (
            <img
              src={signature}
              alt="signature"
              className="sigCanvas m-2"
            />
          ) : (
            <SignatureCanvas
              ref={signatureRef}
              canvasProps={{ width: 400, height: 200, className: "sigCanvas" }}
              disabled={signature}
            />
          )}
        </>
      )}
      <div
        className="col-md-12 mb-2 text-center "
        style={{ position: "relative" }}
      >
        {!showSignatureCanvas && (
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={() => setShowSignatureCanvas(true)}
            id="nombreBtnFirma"
          >
            Agregar Firma
          </button>
        )}
        {showSignatureCanvas && (
          <>
            {!signature && (
              <>
                <button
                  type="button"
                  className="btn btn-warning m-1 btn-sm"
                  onClick={clearSignature}
                  id="LimpiarPanel"
                >
                  Limpiar
                </button>
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  onClick={saveSignature}
                  id="OkfirmaCrud"
                >
                  Guardar firma
                </button>
              </>
            )}
            {signature && (
              <button
                type="button"
                className="btn btn-warning btn-sm"
                onClick={() => setSignature(false)}
                id="CLearfirmaCrud"
              >
                Cambiar firma
              </button>
            )}
          </>
        )}
        <br />
      </div>
    </div>
  );
};